import ImageCompressWorker from 'worker-loader!./imageCompressWebpackWorker.js';

/**
 * Create a Webpack 4 compatible worker bundled by worker-loader.
 *
 * The worker keeps the package's JSquash encoders and WASM execution off the
 * main thread while avoiding the Webpack 5-only new URL(import.meta.url) path.
 *
 * @returns {Worker}
 */
export function createDefaultWorker() {
  return new ImageCompressWorker();
}

/**
 * Run one compression attempt and preserve the package worker-client contract.
 *
 * @param {File|Blob} file image input
 * @param {Object} options worker compression options
 * @param {Object} [runtimeOptions={}] runtime options
 * @returns {Promise<Object>} worker result
 */
export function runCompressionWorker(file, options, runtimeOptions = {}) {
  var createWorker = runtimeOptions.createWorker || createDefaultWorker;
  var timeout = runtimeOptions.timeout;
  var worker = createWorker();

  if (!worker) {
    return Promise.reject(
      new Error('Unable to create image compression worker')
    );
  }

  return new Promise(function (resolve, reject) {
    var timer = globalThis.setTimeout(function () {
      worker.terminate();
      reject(new Error('Image compression timed out'));
    }, timeout);

    worker.onmessage = function (event) {
      globalThis.clearTimeout(timer);
      worker.terminate();

      if (event.data && event.data.ok) {
        resolve(event.data);
        return;
      }

      reject(
        new Error(
          (event.data && event.data.error) || 'Image compression worker failed'
        )
      );
    };

    worker.onerror = function (event) {
      globalThis.clearTimeout(timer);
      worker.terminate();
      reject(
        new Error((event && event.message) || 'Image compression worker failed')
      );
    };

    worker.postMessage({ file: file, options: options });
  });
}
